import { useTranslation } from 'react-i18next';

import MultilingualQuill from 'packages/kakapo-ui-kit/components/forms/controls/MultilingualQuill';
import Property from 'settings/conversations/components/modals/common/Property';

export default function Paragraph(props: { label?: string; name?: string }) {
	const { t } = useTranslation();

	return (
		<Property
			title={props.label ?? t('common.settings.evaluationForms.properties.paragraph.title')}
		>
			<MultilingualQuill name={props.name ?? 'title'} />
		</Property>
	);
}
